import { deleteCoupons } from "@/api/coupons";
import { CouponsQueryKeys } from "@/tanstackQuery/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeleteCoupons = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCoupons,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.History],
      });
    },
  });
};
